'use client';

import Image from 'next/image';
import ContactColumn from './ContactColumn';

export default function ContactSidebarLayout({
  title,
  children,
  image,
}: {
  title?: string;
  image?: string;
  children: React.ReactNode;
}) {
  return (
    <div className='relative mx-auto w-full max-w-[90rem]'>
      <div className='relative grid grid-cols-1 gap-12 md:grid-cols-[2fr_1fr]'>
        <div className='max-w-full'>
          {image && (
            <div className='relative pt-[46%] '>
              <Image src={image} alt='' fill className='object-cover' />
            </div>
          )}
          {title && (
            <div className='prose relative my-10'>
              <h1>{title}</h1>
            </div>
          )}
          {children}
        </div>
        <div className='md:col-span-1'>
          <ContactColumn />
        </div>
      </div>
    </div>
  );
}
